import React, {FormEvent, useState} from 'react';
import {observer} from 'mobx-react-lite';
import intl from 'react-intl-universal';
import {useAppState, useUserState, useDsManager, useRootStore} from "@stores/AppStateContext";
import {useCrudServices} from "../../../../platform/hooks/useServiceCombinations";

import {Button} from "../../../components/Button";
import {MaterialUiInput} from "../../../components/form/material-ui-input/MaterialUiInput";
import {updateCurrentUserWithCognito} from "../../../../actions/clientUser/user";
import {updateCompanyNameAndSlug} from "../../../../actions/clientUser/company";
import {ModalBase} from "../components/ModalBase";

import {MODALS} from '../modal-names';

export const FillInfo = observer(() => {
    const appState = useAppState();
    const userState = useUserState();
    const dsManager = useDsManager();
    const rootStore = useRootStore();
    const crudServices = useCrudServices();
    const [firstName, setFirstName] = useState<string>(userState!.user?.name || '');
    const [lastName, setLastName] = useState<string>(userState!.user?.family_name || '');
    const [companyName, setCompanyName] = useState<string>(dsManager!.clientAR?.row?.name || '');
    const [isLoading, setIsLoading] = useState(false);

    const activeModal = appState.topModal;

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsLoading(true);
        await updateCurrentUserWithCognito(crudServices, userState!, {
            name: firstName,
            family_name: lastName,
        });
        if (userState!.isCurrentUserOwner && companyName !== '') {
            await updateCompanyNameAndSlug(crudServices, userState!, rootStore, companyName);
        }
        setIsLoading(false);
        appState.setModal(null);
    }

    const closeFillInfo = () => {
        appState.setModal(null);
    }

    return (
        <ModalBase
            open={activeModal === MODALS.FILL_INFO}
            header={intl.get('fill_info.tell_us_about_you').d('Tell us about you')}
            onClose={closeFillInfo}
            maxWidth={512}
        >
            <form onSubmit={handleSubmit}>
                <div className='body-large'>
                    {intl.get('fill_info.note').d('When you engage with Pages, your name will be visible to other members of your Company.')}
                </div>
                <div className={'Auth-fill-info-line  Auth-input'}>
                    <MaterialUiInput
                        className={'Auth-fill-info-line__item'}
                        isRequired
                        name="name"
                        value={firstName}
                        onChange={setFirstName}
                        label={intl.get('fill_info.first_name').d('First Name')}
                    />
                    <MaterialUiInput
                        className={'Auth-fill-info-line__item'}
                        isRequired
                        name="lastname"
                        value={lastName}
                        onChange={setLastName}
                        label={intl.get('fill_info.last_name').d('Last name')}
                    />
                </div>
                {
                    userState!.isCurrentUserOwner
                        ? (
                            <MaterialUiInput
                                className={'Auth-input'}
                                isRequired
                                name="company_name"
                                fullWidth={true}
                                value={companyName}
                                onChange={setCompanyName}
                                label={intl.get('fill_info.company_name').d('Company name')}
                            />
                        )
                        : null
                }
                <Button
                    type="primary"
                    className="Auth-input Auth-btn"
                    htmlType="submit"
                    fullWidth
                    text={intl.get('fill_info.save').d('Save')}
                    loading={isLoading}
                    size={'lg'}
                />
            </form>
        </ModalBase>
    );
})
